import axios from 'axios'
import { message as msg } from 'antd'
import { LOGIN_PATHNAME } from "@/router"

const API_BASE_URL = process.env.REACT_APP_API_URL;
  
const instance = axios.create({
  // baseURL: 'http://10.3.13.249:10090',
  baseURL: API_BASE_URL,
  timeout: 10 * 1000,
  validateStatus: function (status) {
    return status >= 200 && status < 500 || status === 401 || status === 403; 
  }
})

instance.interceptors.request.use(
  config => {
    if (typeof window !== 'undefined') {
      const token = localStorage.getItem('token');
      const merchantId = localStorage.getItem('merchantId');
      token && (config.headers.Authorization = `Bearer ${token}`);
      merchantId && (config.headers.merchantId = merchantId)
    }
    return config
  }
)

instance.interceptors.response.use(res => {
  if (res.status == 403) {
    msg.error('权限不足')
    return
  }
  const resData = (res.data || {}) as ResType
  const { code, data = {}, message } = resData
  if (code != 0) {
    if (code == 403) {
      msg.error('权限不足')
      return
    }
    if (code == 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('merchantId')
      msg.error('登录已过期，请重新登录')
      setTimeout(() => {
        window.location.href = `${LOGIN_PATHNAME}`
      }, 200)
      return
    }
  }
  return resData as any
})

export default instance

export type ResType = {
  code: number
  data?: ResDataType
  statistics?: ResDataType
  message?: string
  messageType?: string
}

export type ResDataType = {
  [key: string]: any
}

export async function get(url:string){
  const data = (await instance.get(url));
  return data
}

export async function post(url:string,params:ResDataType){
  const data = (await instance.post(url,{...params}))
  return data
}
